import { get } from 'lodash';

import { FIELD_VALUE_LABELS } from '@funnels/constants';

export default function getFieldValueLabel(value: any, defaultValue: any = '--') {
  return get(FIELD_VALUE_LABELS, value, defaultValue);
}
